import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ResultSection() {
  const results = ['Vas a escribir sin ansiedad.', 'Vas a notar más interés.', 'Vas a dejar de perseguir.', 'Vas a marcar ritmo.', 'Vas a sentir control.'];
  return <section className="py-24 px-4 bg-brand-black" data-id="element-158">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-159">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-12" data-id="element-160">
          Después de aplicar{' '}
          <span className="text-brand-red" data-id="element-161">Código Deseo™</span>:
        </h2>

        <div className="space-y-4 mb-12" data-id="element-162">
          {results.map((res, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center justify-center space-x-3" data-id="element-163">
              <div className="bg-green-500/20 p-1 rounded-full" data-id="element-164">
                <Check className="w-5 h-5 text-green-500" data-id="element-165" />
              </div>
              <span className="text-xl text-gray-200" data-id="element-166">{res}</span>
            </motion.div>)}
        </div>

        <p className="text-lg text-gray-400 italic" data-id="element-167">
          "No porque cambiaste quién sos. Sino porque cambiaste el marco."
        </p>
      </div>
    </section>;
}